const windowUrl = window.location.href

export const isProd = windowUrl.includes('app.accurateconverter.com')

export const isStaging = windowUrl.includes('staging.accurateconverter.com')

export const isDev = windowUrl.includes('localhost')
